import { render, staticRenderFns } from "./ApplyRemoveTag.vue?vue&type=template&id=caaf8b2e&scoped=true"
import script from "./ApplyRemoveTag.vue?vue&type=script&lang=js"
export * from "./ApplyRemoveTag.vue?vue&type=script&lang=js"
import style0 from "./ApplyRemoveTag.vue?vue&type=style&index=0&id=caaf8b2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caaf8b2e",
  null
  
)

export default component.exports